import api from './api';

const suppliersService = {
    // Suppliers management
    getAllSuppliers: async () => {
        const response = await api.get('/api/admin/suppliers');
        return response.data;
    },

    getSupplierById: async (id) => {
        const response = await api.get(`/api/admin/suppliers/${id}`);
        return response.data;
    },

    createSupplier: async (data) => {
        const response = await api.post('/api/admin/suppliers', data);
        return response.data;
    },

    updateSupplier: async (id, data) => {
        const response = await api.put(`/api/admin/suppliers/${id}`, data);
        return response.data;
    },

    deleteSupplier: async (id) => {
        const response = await api.delete(`/api/admin/suppliers/${id}`);
        return response.data;
    },

    // Products management
    addProductToSupplier: async (supplierId, data) => {
        const response = await api.post(`/api/admin/suppliers/${supplierId}/products`, data);
        return response.data;
    },

    updateSupplierProduct: async (id, data) => {
        const response = await api.put(`/api/admin/supplier-products/${id}`, data);
        return response.data;
    },

    removeProductFromSupplier: async (id) => {
        const response = await api.delete(`/api/admin/supplier-products/${id}`);
        return response.data;
    }
};

export default suppliersService;
